
import request from '@/axios/index.js'
// 融资申请书
export function borrowedContractList(data,loading) {
    return request.axios({
        url: '/user/goldseller/borrowedContractList',
        data: data,
        loading:loading
    })
}
// 融资放款信息查询
export function fncDetailsApi(fncJrnlId) {
  return request.axios({
      url: `/user/loan/fncDetails/${fncJrnlId}`,
      type:"get",
  })
}



// WEBPACK FOOTER //
// ./src/api/borrow.js